/*!
 * beDate Jquery plugin:
 * Plugin para la selección de pais, provincia y ciudad
 * Author: @pablocrs
 */

;(function ( $, window, document, undefined ) {


    // Create the defaults once
    var pluginName = 'beLocation',
        defaults = {
            selectCountry: "#beLocation-country",
            selectState: "#beLocation-state",
            selectCity: "#beLocation-city",
            apiUrl: window.location.origin,
            locale: 'es'
        };

    // The actual plugin constructor
    function Plugin( element, options ) {
        this.element = element;
        this.$element = $(element);

        this.options = $.extend( {}, defaults, options) ;

        this._defaults = defaults;
        this._name = pluginName;

        this.selects = [
            this.$element.find(this.options.selectCountry),
            this.$element.find(this.options.selectState),
            this.$element.find(this.options.selectCity)
        ];

        this.init();
    }

    Plugin.prototype.init = function () {
        var Plugin = this;

        Plugin.setEvents();
        Plugin.loadSelect(Plugin.selects[0],'countries',Plugin.options.locale);

        Plugin.getLocale();

        Plugin.selects[0].on('change',function(){
            Plugin.clearAll();
            $.each(Plugin.selects,function (i,select) {
                if(i > 0) {
                    Plugin.selects[i].val('null').empty().trigger('change');
                }
            });
        });

        Plugin.selects[0].on('select2:unselect',function(){
            Plugin.clearAll();
            $.each(Plugin.selects,function (i,select) {
                Plugin.selects[i].val('null').empty().trigger('change');
            });
        });

        $.each(Plugin.selects,function (i,select) {
            if(i > 0){
                if(!Plugin.selects[i].val()){
                    Plugin.selects[i].prop('disabled',true).select2('data',null);
                }
            }
        });
    };

    /// Recoge el locale activo
    //
    Plugin.prototype.getLocale = function(){
        var Plugin = this;

        var localePath = $(location).attr('pathname');

        localePath.indexOf(1);
        localePath.toLowerCase();
        localePath = localePath.split("/")[1];

        if(localePath === 'en'){
            Plugin.options.apiUrl = window.location.origin + '/' + localePath;
            Plugin.options.locale = 'en';
        }
    };

    /// Carga paises en el primer select
    //
    Plugin.prototype.loadSelect = function(select,type,locale){
        var Plugin = this;

        var url = Plugin.options.apiUrl + '/master/'+ type;

        if(locale){
            url = url + '/' + locale;
        }

        select.select2('data',null);

        select.select2({
            allowClear: true,
            ajax: {
                url: url,
                dataType: 'json',
                delay: 250,
                method: 'GET',
                async: false,
                data: function (params) {
                    return {
                        search: {name:params.term}, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {

                    params.page = params.page || 1;

                    if(data.data){
                        return {
                            results: $.map(data.data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total
                            }
                        };
                    }
                    else{
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    slug: item.locale,
                                    id: item.id
                                }
                            }),
                            pagination: {
                                more: (params.page * 30) < data.total_count
                            }
                        };
                    }
                },
                cache: true
            }
        });

        if(select.data('selected')){
            select.val(select.data('selected')).trigger('change');
        }
    };

    // Congfigura evento change en cada select
    //
    Plugin.prototype.setEvents = function(){
        var Plugin = this;

        $.each(Plugin.selects,function (i,selector) {
            $(selector).on('change',function (e) {
                Plugin.enableNext(i,Plugin.selects);
            });
        });
    };

    /// Quita disabled del siguiente select del array
    //
    Plugin.prototype.enableNext = function(id,array){
        var Plugin = this;

        var next = id + 1;

        if(array[next]){
            array[next].prop('disabled',false);

            if(next === 1){
                Plugin.loadSelect($(array[next]),'states/active/country/'+$(array[0]).val(),false);
            }
            else if(next === 2){
                Plugin.loadSelect($(array[next]),'cities/active/state/'+$(array[1]).val(),false);
            }
            else{
                Plugin.loadSelect($(array[next]),'countries',Plugin.options.locale);
            }
        }
    };

    Plugin.prototype.clearAll = function(){
        $.each(Plugin.selects,function (i,select) {
            if(i > 0){
                Plugin.selects[i].select2('data',null);
                Plugin.selects[i].val(null).trigger('change');
                if(!Plugin.selects[i].val()){
                    Plugin.selects[i].prop('disabled',true);
                }
            }
        });
    };

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new Plugin( this, options ));
            }
        });
    }

})( jQuery, window, document );